import { useLocation, useNavigate } from "react-router-dom";

type LocationState = {
    from?: {
        pathname: string;
        search?: string;
    };
};

export function withNavigation(Component) {
    return function WrappedComponent(props) {
        const navigate = useNavigate();
        const location = useLocation() as { state?: LocationState };

        return <Component {...props} location={location} navigate={navigate} />;
    };
}